import { render, staticRenderFns } from "./CandidateMagicLink.vue?vue&type=template&id=adcdc8a4&"
import script from "./CandidateMagicLink.vue?vue&type=script&lang=js&"
export * from "./CandidateMagicLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports